import { render, staticRenderFns } from "./Form28Layout.vue?vue&type=template&id=be9548d2&scoped=true"
import script from "./Form28Layout.vue?vue&type=script&lang=ts"
export * from "./Form28Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=be9548d2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9548d2",
  null
  
)

export default component.exports